export const previousUsagesCode = {
  payPerDrive: 'payPerDrive'
}
